define('OutSystems/ReactView/convertCssTransitionClassNames',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var convertCssTransitionClassNames = function (cssTransitionBaseName) { return ({
        appear: "".concat(cssTransitionBaseName, "-appear"),
        appearActive: "".concat(cssTransitionBaseName, "-appear-active"),
        appearDone: "".concat(cssTransitionBaseName, "-appear-done"),
        enter: "".concat(cssTransitionBaseName, "-enter"),
        enterActive: "".concat(cssTransitionBaseName, "-enter-active"),
        enterDone: "".concat(cssTransitionBaseName, "-enter-done"),
        exit: "".concat(cssTransitionBaseName, "-leave"),
        exitActive: "".concat(cssTransitionBaseName, "-leave-active"),
        exitDone: "".concat(cssTransitionBaseName, "-leave-done"),
    }); };
    exports.default = convertCssTransitionClassNames;
});
//# sourceMappingURL=convertCssTransitionClassNames.js.map;
